module.exports = __webpack_public_path__ + "img/cross.ff3f201d.svg";